import { DeliveryMethod } from '../models/deliveryMethod';

/**
 * Return an object with the shipping settings, including `backupDeliveryMethod` and
 * `cutoffDate` for the shipping delivery method on an event.
 *
 * @param data the data response from the delivery_method events call
 */
export const transformShippingSettings = (data: {
    delivery_methods: Array<{
        id: DeliveryMethod;
        backup_delivery_method?: DeliveryMethod;
        cutoff_date?: string;
    }>;
}) => {
    const deliveryMethods = data['delivery_methods'];

    const shippingDeliveryMethod = deliveryMethods.find(
        (item) => item.id === DeliveryMethod.standardShipping,
    );

    return shippingDeliveryMethod
        ? {
              shippingSettings: {
                  backupDeliveryMethod:
                      shippingDeliveryMethod.backup_delivery_method,
                  cutoffDate: shippingDeliveryMethod.cutoff_date,
              },
          }
        : {};
};
